module.exports = __webpack_public_path__ + "static/img/应用案例BG.6c8bc34.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/products/应用案例BG.png
// module id = WmvS
// module chunks = 0